import { parseFilename } from './files';
import axios from 'axios';
import { CASH_TRACKER_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface CashTrackerSummary {
  as_of: string;
  range_start: string;
  range_end: string;
  bank_detail: Record<string, number>;
  bank: number;
  total_rec: number;
  total_pay: number;
  closing: number;
  overdue: boolean;
  sheets: string[];
}

export interface CashTrackerResult {
  blob: Blob;
  filename: string;
  summary: CashTrackerSummary | null;
}

export async function buildCashTracker(
  inputFile: File,
  asOfDate?: string,
  outputFilename?: string
): Promise<CashTrackerResult> {
  const formData = new FormData();
  formData.append('input_file', inputFile);
  if (asOfDate && asOfDate.trim()) {
    formData.append('as_of_date', asOfDate.trim());
  }
  if (outputFilename && outputFilename.trim()) {
    formData.append('output_filename', outputFilename.trim());
  }

  try {
    const response = await axios.post(
      `${CASH_TRACKER_BASE_URL}/cash-tracker/build`,
      formData,
      { responseType: 'blob' }
    );

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      outputFilename || 'Daily_Cash_Tracker.xlsx'
    );

    let summary: CashTrackerSummary | null = null;
    const rawSummary = response.headers['x-summary'];
    if (rawSummary) {
      try {
        summary = JSON.parse(rawSummary) as CashTrackerSummary;
      } catch {
        summary = null;
      }
    }

    return { blob, filename, summary };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message = (data && data.detail) || `Build failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
